import axios from "axios"

class Visionboard {
	constructor() {
		if (document.querySelector("#visionboard")) {
			axios.defaults.headers.common["X-WP-Nonce"] = academyData.nonce
			this.visionContainer = document.getElementById("visionboard").querySelector(".toggle-content");
			this.allImages = document.getElementById("visionboard").getElementsByClassName("img-link");
			this.toggleVision = document.getElementById("visionboard").querySelector(".toggle-header");
			this.visionboard = document.getElementById("visionboard");
			this.imageInput = document.getElementById("image-input");
			this.events();
		}
	}

	events() {
		this.visionContainer.addEventListener("click", e => this.clickHandler(e));
		this.toggleVision.addEventListener("click", () => this.showVisionboard());
		this.imageInput.addEventListener('change', e => this.uploadImage(e));

		for (let i = 0; i < this.allImages.length; i++) {
			this.allImages[i].addEventListener("click", e => this.selectImage(e));
		}
	}

	clickHandler(e) {
        if (e.target.classList.contains("toggle-edit")) this.toggleEdit();
    }

	toggleEdit() {
		for (let i = 0; i < this.allImages.length; i++) {
			if (!this.allImages[i].querySelector(".bg-overlay").classList.contains("d-none")) {
				this.allImages[i].querySelector(".bg-overlay").classList.add("d-none");
				this.allImages[i].setAttribute("data-lightbox", "gallery-item");
			} else {
				this.allImages[i].querySelector(".bg-overlay").classList.remove("d-none");
				this.allImages[i].removeAttribute("data-lightbox");
			}
		}
	}

	selectImage(e) {
		e.preventDefault();
		if (!this.allImages[0].querySelector(".bg-overlay").classList.contains("d-none")) {
			const imageNumber = e.target.closest('a').dataset.img;
			this.imageInput.setAttribute("data-img", imageNumber);
			this.imageInput.click();
		}
	}

	async uploadImage(e) {
		const file = e.target.files[0];
	
		if (!file) {
			return;
		}
	
		if (!file.type.startsWith('image/')) {
			const alertMsg = '<div data-notify-type="warning" data-notify-timeout="8000" data-notify-msg="<i class=\'icon-warning-sign me-1\'></i> Ungültiger Dateityp. Nur Bilddateien sind erlaubt."></div>';
			SEMICOLON.widget.notifications({ el: alertMsg });
			e.target.value = '';
			return;
		}
	
		if (file.size > 20 * 1024 * 1024) {
			const alertMsg = '<div data-notify-type="warning" data-notify-timeout="8000" data-notify-msg="<i class=\'icon-warning-sign me-1\'></i> Die ausgewählte Datei ist zu groß. Bitte wähle ein Bild, das kleiner als 20 MB ist."></div>';
			SEMICOLON.widget.notifications({ el: alertMsg });
			e.target.value = '';
			return;
		}
	
		const reader = new FileReader();
		reader.onload = event => {
			const img = new Image();
			img.onload = () => {

				if (img.width < 400 || img.height < 400) {
					const alertMsg = `<div data-notify-type="warning" data-notify-timeout="8000" data-notify-msg="<i class=\'icon-warning-sign me-1\'></i> Das ausgewählte Bild ist mit ${img.width} x ${img.height} Pixel zu klein. Bitte wähle ein Bild, das mindestens 400 Pixel groß ist."></div>`;
                	SEMICOLON.widget.notifications({ el: alertMsg });
					e.target.value = '';
					return;
				}

				const imageNumber = e.target.dataset.img;
				let imageContainer = 'landscape';

				if (this.allImages[imageNumber - 1].parentNode.classList.contains("portrait")) {
					imageContainer = 'portrait';
				}

				const maxRes = 1536; // WordPress resolution. Does not generate more images for performance
				let width = img.width;
				let height = img.height;
			
				if (width > height) {
					if (width > maxRes) {
						height *= maxRes / width;
						width = maxRes;
					}
				} else {
					if (height > maxRes) {
						width *= maxRes / height;
						height = maxRes;
					}
				}

				const canvas = document.createElement('canvas');
				canvas.width = width;
				canvas.height = height;
				const ctx = canvas.getContext('2d');
				ctx.drawImage(img, 0, 0, width, height);
			
				canvas.toBlob(scaledImageBlob => {
					scaledImageBlob = new File([scaledImageBlob], file.name, { type: 'image/jpeg' });

					let formData = new FormData();
					formData.append('file', scaledImageBlob, file.name);
					formData.append('imageNumber', imageNumber);
					formData.append('imageContainer', imageContainer);
	
					fetch(`${academyData.root_url}/wp-json/academy/v1/manage-visionboard`, {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'X-WP-Nonce' : academyData.nonce
						},
						body: formData,
					})
					.then(response => {
						if (!response.ok) {
							throw new Error('Ein unbekannter Fehler beim Upload ist aufgetreten. Bitte versuche es noch einmal oder wähle ein anderes Bild. Kontaktiere gerne den Support, falls du weitere Hilfe benötigst.');
						}
						return response.json();
					})
					.then(data => {
						for (let i = 0; i < this.allImages.length; i++) {
							let currentImageNumber = this.allImages[i].dataset.img;
							if (currentImageNumber == imageNumber) {
								this.allImages[i].href = data.full_url;

								if (this.allImages[i].parentNode.classList.contains("portrait")) {
									this.allImages[i].querySelector(".img-fluid").src = data.portrait_url;
								} else {
									this.allImages[i].querySelector(".img-fluid").src = data.landscape_url;
								}
							}
						}
					})
					.catch(error => {
						const alertMsg = `<div data-notify-type="error" data-notify-timeout="8000" data-notify-msg="<i class=\'icon-remove-sign me-1\'></i> ${error.message}"></div>`;
						SEMICOLON.widget.notifications({ el: alertMsg });
					});			
				}, 'image/jpeg', 0.9);
			};
			img.src = event.target.result;
		}
		reader.readAsDataURL(file);
	}

	async showVisionboard() {
		try {
			let visible = true;

			if (this.visionboard.classList.contains("toggle-active")) {
				visible = false;
			}

			await axios.post(academyData.root_url + "/wp-json/academy/v1/manage-visionboard", { "visible": visible });
		} catch (e) {
			console.log(e);
		}
	}
}

export default Visionboard;
